/**
 * The Google profile picture, falling back to the initial when it fails to
 * load. `referrerPolicy="no-referrer"` is what Google's image host needs; the
 * old fetch-into-a-blob workaround only existed because of the COEP header.
 */
import { useState } from 'react'

export function Avatar({ name, picture, size = 32 }: { name: string; picture?: string | null; size?: number }) {
  const [failed, setFailed] = useState(false)
  const initial = (name.trim()[0] ?? '?').toUpperCase()
  return (
    <span className="avatar" style={{ width: size, height: size }} aria-hidden="true">
      {picture && !failed ? (
        <img src={picture} alt="" referrerPolicy="no-referrer" onError={() => setFailed(true)} />
      ) : (
        <span className="avatar-initial">{initial}</span>
      )}
    </span>
  )
}
